/**
 * Generate a strong, human-readable temporary password.
 * Uses upper + lower + digit + symbol, excluding ambiguous glyphs (0/O, 1/l/I).
 * Guarantees at least one char from each class, then Fisher-Yates shuffles.
 */
export function generateTempPassword(len = 12) {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnpqrstuvwxyz";
  const digit = "23456789";
  const symbol = "!@#$%^&*";
  const all = upper + lower + digit + symbol;
  const rand = (s) => s[Math.floor(Math.random() * s.length)];
  const out = [rand(upper), rand(lower), rand(digit), rand(symbol)];
  while (out.length < len) out.push(rand(all));
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out.join("");
}
